import React from 'react';
import './PromptAutomatorGeneratePanel.css';

function PromptAutomatorGeneratePanel({ 
  generatedPrompt,
  setNotification
}) {

  const copyGeneratedPrompt = async () => {
    if (!generatedPrompt) return;
    
    try {
      await navigator.clipboard.writeText(generatedPrompt);
      setNotification('Prompt copied to clipboard');
    } catch (error) {
      console.error('Failed to copy prompt:', error);
      setNotification('Failed to copy prompt');
    } finally {
      setTimeout(() => setNotification(''), 3000);
    }
  };

  if (!generatedPrompt) {
    return null;
  }

  return (
    <div className="generate-panel">
      <div className="generate-panel__content">
        <div 
          className="generate-panel__display"
          onClick={copyGeneratedPrompt}
          title="Click to copy prompt"
        >
          <div className="prompt-text clickable">
            {generatedPrompt}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromptAutomatorGeneratePanel;